var keyMirror = require("keymirror");

module.exports = {
  COMPANY: {
    URL: "https://www.planblanc.fr/",
    TEL: "01 76 44 03 27",
    NAME: "PlanBlanc",
    EMAIL: "planblanc@hublo.com"
  },

  LINKEDIN: {
    ADRI_ID: "adrien-beata-450ab629",
    ANTOINE_ID: "antoine-loron-64993523"
  },

  EMAIL: {
    CONTACT: "planblanc@medgo.fr",
    FROM_CHRIS: "chris@medgo.fr",
    FROM_ADRIEN: "adrien@medgo.fr",
    FROM_ANTOINE: "antoine@medgo.fr"
  },

  ActionTypes: keyMirror({
    EDIT_CSRF: null,

    DID_SIGN_UP: null,
    WILL_SIGN_UP: null,
    WILL_LOG_IN: null,
    DID_FORGET_PASSWORD: null,
    DID_SEND_EMAIL_PASSWORD: null,
    DID_RESEND_EMAIL_PASSWORD: null,
    DID_RESEND_EMAIL_CONFIRMATION_ACCOUNT: null,

    EDIT_PROFILE_ADMIN: null,
    EDIT_PROFILE_ADMIN_WITHOUT_SETTING: null,
    EDIT_INSTITUTION: null,
    EDIT_SERVICES: null,
    EDIT_INSTITUTION_HAS_WORKER_FROM_WORKER: null,
    EDIT_INSTITUTIONS_FROM_WORKER: null,

    EDIT_TO_BE_ADDRESSED_WORKERS: null,
    EDIT_WORKERS: null,
    EDIT_INVITED_WORKERS: null,
    EDIT_WORKERS_FROM_SEARCH: null,
    EDIT_INVITED_WORKERS_FROM_SEARCH: null,
    EDIT_TO_BE_ADDRESSED_WORKERS_FROM_SEARCH: null,

    OPEN_MODAL: null,
    OPEN_MODAL_FROM_MODAL: null,
    EDIT_MISSION: null,
    EDIT_DATA_MISSION: null,

    EDIT_MISSIONS: null,
    EDIT_MISSION_REQUESTS: null,

    EDIT_PROFILE_USER: null,

    EDIT_USER_MISSIONS: null,
    EDIT_USER_MY_MISSIONS: null,
    EDIT_USER_MY_MISSIONS_HISTORY: null,
    SELECT_USER_MISSION: null,

    SET_PROFILE_PICTURE: null,

    EDIT_STATE_PROGRESS: null,

    EDIT_AVAILABILITY: null,
    EDIT_SLOTS: null,
    REMOVE_SLOTS: null,

    MEDGO_EDIT_WORKERS: null,
    MEDGO_EDIT_INSTITUTIONS: null,
    MEDGO_EDIT_INFO: null,
    MEDGO_EDIT_MISSIONS: null,

    EDIT_ADMIN_IN_INSTITUTIONS: null,
    CHANGE_ADMIN_IN_INSTITUTION_NOTIFICATION_SERVICE: null,

    EDIT_NOTIFICATION_ADMIN: null,

    EDIT_SELECTED_INVITATION_WORKER: null,
    EDIT_SELECTED_TO_BE_ADDRESSED_WORKER: null,
    EDIT_TO_BE_ADDRESSED_INSTITUTION_HAS_WORKER: null,

    EDIT_SCHEDULE: null,

    EDIT_DATES_PLANNING: null,
    EDIT_RECAP_MISSIONS: null,
    SORT_RECAP_MISSIONS: null,

    EDIT_MESSAGE_TO_BE_SENT: null,

    SELECT_DETAILED_MISSION: null,

    EDIT_POTENTIAL_WORKERS: null,

    EDIT_CREDITS: null,

    EDIT_POTENTIAL_WORKERS_MISSIONS: null,
    EDIT_POTENTIAL_WORKERS_DETAILS_FROM_GTA: null,

    EDIT_INFO_ON_WORKER_IN_INSTITUTION: null,
    EDIT_INFO_ON_WORKER_IN_INSTITUTION_HAS_WORKER: null,

    EDIT_DATASETS: null,
    EDIT_FILTERS: null,
    EDIT_TABLE_CONFIG_OBJECTS: null,

    EDIT_CRISIS_SCRIPTS: null,
    EDIT_CRISIS_SCRIPT_LAUNCHING: null,
    EDIT_CRISIS_SCRIPT_LAUNCHINGS: null,
    EDIT_CRISIS_SCRIPT_LAUNCHING_MESSAGES: null
  }),

  PayloadSources: keyMirror({
    SERVER_ACTION: null,
    VIEW_ACTION: null
  }),

  WhichModal: keyMirror({
    MODAL_INVITATION: null,
    MODAL_WORKER: null,
    MODAL_INSCRIPTION_NEW_INSTITUTION: null,
    MODAL_DETAIL_MISSION: null,
    MODAL_DETAIL_MISSION_RETURN: null,
    MODAL_ACCEPT_USER_MISSION: null
  }),

  TypeInput: keyMirror({
    PASSWORD: null,
    FIRST_NAME: null,
    LAST_NAME: null,
    EMAIL: null,
    ADDRESS: null,
    PHONE: null,
    MOBILEPHONE: null,
    DATA_ADDRESS: null,
    POSTAL_CODE: null,
    LAT: null,
    LNG: null,

    INSTITUTION: null,
    BEGIN_AT_MOMENT: null,
    END_AT_MOMENT: null,
    NUMBER_WORKED_HOURS: null,
    SERVICE: null,

    NAME_INSTITUTION: null,
    NAME_ADMIN: null,
    TOKEN: null,
    TEXT_GOOGLE_AUTOCOMPLETE: null
  }),

  Random: {
    ID_DOCUMENT_PROFILE_PICTURE: 1,
    ID_DOCUMENT_RESUME: 4,
    ID_WORKER__INFO_ON_WORKER_FOR_INVITATION: -1
  },

  mission: "mission",
  missions: "missions",
  Mission: "Mission",
  Missions: "Missions",
  Remplaçants: "Remplaçants",
  Remplaçant: "Remplaçant",
  remplaçant: "remplaçant",
  remplaçants: "remplaçants"
};



// WEBPACK FOOTER //
// ./assets/react/constants/AppConstants.js